import React from "react";

function PartnerCellRenderer({value}){
    return <span>{value ? value : 0}</span>
}

export default PartnerCellRenderer;